import React from 'react';
import { getContext } from 'common';
import Styled from './styles';

export interface LaunchPadFooterProps extends React.ComponentPropsWithRef<'div'> {
  /** Place content here. */
  children: React.ReactNode;
}

/** Place LaunchPad footer content here (eg. copyright info) */
const LaunchPadFooter = React.forwardRef<HTMLElement, LaunchPadFooterProps>((props: LaunchPadFooterProps, ref) =>
  getContext(({ RTL }) => {
    const { children, ...otherProps } = props;
    return (
      <Styled.LaunchPadFooter $rtl={RTL} ref={ref} {...otherProps}>
        {children}
      </Styled.LaunchPadFooter>
    );
  }));

LaunchPadFooter.displayName = 'LaunchPadFooter';

/* Exports */
export { LaunchPadFooter as default };
